define('plugin/pwa/view/PwaPushView',['require','lib/view/LayoutView','Config','view/module/MessageView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');
    var MessageView = require('view/module/MessageView');

    /**
     *      *
     * @class PwaPushView
     */
    return LayoutView.extend({

        template: '#pwa_push_notification',

        ui: {
             subscribeBtn: '.btn-push-subscribe',
            // pushSuccessBlock: '.push-success'
        },

        events: {
            'click @ui.subscribeBtn' : 'onSubscribe'
        },

        regions: {
            'notification': '#sb_pwa_notification',
        },

        _bodyClass: 'has-push-alert',

        _clientModel : null,
        _deviceModel : null,
        pushNotifyObj : null,
        pushNotifyReady : false,
        pushNotifySubscribed : null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');
            this._deviceModel = this.getOption('deviceModel');

            this.initPushNotifyObj();
            LayoutView.prototype.initialize.apply(this);
        },

        onBeforeShow : function () {
            //console.log(this.ui.subscribeBtn);
        },


        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            if(this.pushNotifySubscribed !== null) {
                data.is_subcribed = this.pushNotifySubscribed;
            }
            this._addBodyClass(!data.is_subcribed);
            return data;
        },

        onSubscribe : function () {
            var _this = this;

            if(this.pushNotifyReady){
                this.pushNotifyObj.initPush(function (isSubscribed, token, isBlocked) {
                    if(isSubscribed){
                        _this._subscribeToPush(token);
                    }
                    if(isBlocked){
                        _this.showChildView('notification', new MessageView({
                            type: 'danger',
                            message: Locale.get('The required permissions were not granted and blocked instead.'),
                            triggerEventOnShown: false,
                            autoHideTimeout: 5000,
                        }));
                    }
                });
            }
        },

        initPushNotifyObj : function () {
            var _this = this;
            this.pushNotifyObj = new BrowserPushNotification({
                'is_user_public' : true,
                'worker_path' : '/v2/pwa/service-worker.js',
                'register_worker' : false,
                'tokens' : this._deviceModel.get('push_tokens'),
            }, function () {
                _this.pushNotifyReady = true;

                _this.pushNotifyObj.isSubscribed(function (pushStatus, token) {
                    //console.log(pushStatus, token);
                    _this.pushNotifySubscribed = pushStatus;

                    //if(pushStatus){
                        _this.render();
                    //}
                });

            });
        },

        //Igor ask to add class
        _addBodyClass : function (add){
            if(add){
                jQuery('body').addClass(this._bodyClass);
            } else{
                jQuery('body').removeClass(this._bodyClass);
            }
        },

        _subscribeToPush : function (token) {
            var _this = this;
            var options = null;

            //console.log(this._clientModel);
            //console.log(this._deviceModel);

            if(this._clientModel && this._clientModel.get('id')){
                options = _.extend({
                    client_id: this._clientModel.get('id'),
                    client_hash: this._clientModel.get('client_hash')
                }, options);
            }

            if(this._deviceModel && this._deviceModel.get('id')){
                options = _.extend({
                    device_id: this._deviceModel.get('id'),
                    device_hash: this._deviceModel.get('hash')
                }, options);
            }

            this.model.registerPush(token, options,function (){
                _this.pushNotifySubscribed = true;
               // _this.ui.subscribeBtn.hide();
               // _this.ui.pushSuccessBlock.show();
                _this.render();
                _this._showSubscribeNotification();
            });

        },

        _showSubscribeNotification : function (){
            this.showChildView('notification', new MessageView({
                type: 'success',
                message: 'subscribe_to_push_success',
                triggerEventOnShown: true,
                autoHideTimeout: 5000,
            }));
        }
    });

});
